import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client'
import { setContext } from '@apollo/client/link/context'
import fetch from 'isomorphic-fetch'
import store from '../store/store'

const API_HOST = process.env.GATSBY_API_HOST

const httpLink = createHttpLink({
  fetch,
  fetchOptions: {
    credentials: 'omit',
  },
})

const authLink = setContext((_, { headers }) => {
  const { auth, sagaStore } = store.getState()

  // return the headers to the context so httpLink can read them
  return {
    uri: `${API_HOST}/api/stores/${sagaStore.storeID}/graphql`,
    headers: {
      ...headers,
      authorization: `Bearer ${auth.accessToken}`,
    },
  }
})

const cache = new InMemoryCache({ addTypename: false })

const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: cache,
})

export { client }

// TODO coming soon 期間終了後、ここより上のコードのコメントを外す
// TODO coming soon 期間終了後、ここより下のコードを削除する（開発でcoming soonを外したい場合は、削除ではなく、コメントアウトしてください）

// import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client'
// import { setContext } from '@apollo/client/link/context'
// import fetch from 'isomorphic-fetch'
// import store from '../store/store'

// const API_HOST = process.env.GATSBY_API_HOST

// const httpLink = createHttpLink({
//   fetch,
//   fetchOptions: {
//     credentials: 'omit',
//   },
// })

// const authLink = setContext((_, { headers }) => {
//   const { auth, sagaStore } = store.getState()

//   // return the headers to the context so httpLink can read them
//   return {
//     uri: `${API_HOST}/api/stores/${sagaStore.storeID ?? 'saga-aqua'}/graphql`,
//     headers: {
//       ...headers,
//       authorization: `Bearer ${auth.accessToken}`,
//     },
//   }
// })

// const cache = new InMemoryCache({ addTypename: false })

// const client = new ApolloClient({
//   link: authLink.concat(httpLink),
//   cache: cache,
// })

// export { client }
